import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import AreaPage from "./pages/AreaPage";

/* WEBSITE */
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import TrackRepair from "./pages/TrackRepair";
import Brands from "./pages/Brand";
import Models from "./pages/Models";
import BookRepair from "./pages/Book";
import CustomerLogin from "./pages/CustomerLogin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import ThankYou from "./pages/ThankYou";

/* ADMIN */
import AdminLogin from "./pages/admin/AdminLogin";
import AdminRegister from "./pages/admin/AdminRegister";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminOrders from "./pages/admin/Orders";
import AdminCustomers from "./pages/admin/Cutomer";
import AdminAddModelBrands from "./pages/admin/Brands";
import AdminLayout from "./layouts/AdminLayout";
import Technicians from "./pages/admin/Technicians";
import AdminServices from "./pages/admin/AdminServices";
import AdminRFQ from "./pages/admin/RFQ";

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/admin");
  const isLoginPage = location.pathname === "/login";

  const LegacyAreaRoute = () => {
    const legacyPrefix = "/mobile-repair-service-in-";

    if (location.pathname.startsWith(legacyPrefix)) {
      return <AreaPage />;
    }

    return <Navigate replace to="/" />;
  };

  const SlashAreaRedirect = () => {
    const { area } = useParams();
    return <Navigate replace to={`/mobile-repair-service-in-${area}`} />;
  };

  useEffect(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("adminUser");
  }, []);

  return (
    <>
      <Helmet>
        <title>Servizy | Repair Service</title>
        <meta name="description" content="Servizy provides mobile repair services at home." />
      </Helmet>

      {!isAdminPage && <Header />}
      <ScrollToTop />

      <Routes>

        {/* ✅ AREA ROUTES */}
<Route 
  path="/mobile-repair-service-in/:area" 
  element={<SlashAreaRedirect />} 
/>

        {/* WEBSITE */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/thank-you" element={<ThankYou />} />

        <Route path="/track" element={<TrackRepair />} />
        <Route path="/track/:trackingId/:phone" element={<TrackRepair />} />

        <Route path="/login" element={<CustomerLogin />} />

        <Route path="/brands" element={<Brands />} />
        <Route path="/models/:brand" element={<Models />} />
        <Route path="/book/:brand/:model" element={<BookRepair />} />

        {/* ADMIN */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/register" element={<AdminRegister />} />

        <Route path="/admin" element={<AdminLayout />}>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="rfq" element={<AdminRFQ />} />
          <Route path="customers" element={<AdminCustomers />} />
          <Route path="addmodelbrands" element={<AdminAddModelBrands />} />
          <Route path="services" element={<AdminServices />} />
          <Route path="technicians" element={<Technicians />} />
        </Route>

        {/* Fallback: redirect legacy/unknown routes */}
        <Route path="*" element={<LegacyAreaRoute />} />

      </Routes>

      {!isAdminPage && !isLoginPage && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
